import { Button, Form, Input, Modal } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getSingledayPartSchedule, updateSingledayPartSchedule } from "../../../redux/rtk/features/dayPartSchedule/dayPartSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const DayHoursEdit = ({ data }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { id } = useParams("id");

	const [loader, setLoader] = useState(false);
	// const [date, setDate] = useState(dayjs(data?.date).format());
	const [date, setDate] = useState(data?.date ? dayjs(data.date) : dayjs());
	

	const dispatch = useDispatch();

	const onFinish = async (values) => {
		setLoader(true);
		const resp = await dispatch(updateSingledayPartSchedule({ id, values }));

		if (resp.payload.message === "success") {
			setLoader(false);
			dispatch(getSingledayPartSchedule(id));
		} else {
			setLoader(false);
		}
	};

	const initialValues = {
		name: data?.name,
		// date: moment(data?.date),
		date: data?.date ? dayjs(data.date) : dayjs(),
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding Day Hours");
		setLoader(false);
	};
	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setIsModalOpen(false);
		setLoader(false);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
		setLoader(false);
	};
	return (
		<>
			<button onClick={showModal}>
				<BtnEditSvg size={20} />
			</button>
			<Modal
				title='Public Holiday Edit'
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<Form
					style={{ marginBottom: "50px" }}
					eventKey='department-form'
					initialValues={{ ...initialValues }}
					name='basic'
					labelCol={{
						span: 7,
					}}
					wrapperCol={{
						span: 12,
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'>
					<div>
						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Full Day Hours'
							name='fullDayHours'
							rules={[
								{
									required: true,
									message: "Please input Full Day Hours!",
								},
							]}>
							<Input />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Half Day Hours'
							name='halfDayHours'
							rules={[
								{
									required: true,
									message: "Please input Half Day Hours!",
								},
							]}>
							<Input />
						</Form.Item>
						<Form.Item
							style={{ marginBottom: "10px" }}
							wrapperCol={{
								offset: 7,
								span: 12,
							}}>
							<Button
								onClick={() => setLoader(true)}
								type='primary'
								size='small'
								htmlType='submit'
								block
								loading={loader}>
								Update
							</Button>
						</Form.Item>
					</div>
				</Form>
			</Modal>
		</>
	);
};
export default DayHoursEdit;
